import * as React from 'react';

export interface ModalContainerProps {
  children: React.ReactNode;
}

export const ModalContainer: React.FC<ModalContainerProps> = ({ children }) => {
  return <section className="container">{children}</section>;
};
